export class RateTableRequest {
  Id: number = 0;
  GroupId: number = 0;
  RequestJson: string = "";
  ShareFileUrl: string = "";
  ShareFileExpiry: Date | string | null = "";
  AppCaller: string = "";

  constructor() {
    this.setDefaultIfEmpty();
  }

  setDefaultIfEmpty(): void {
    if (typeof this.ShareFileExpiry === "string") {
      const parsedDate = new Date(this.ShareFileExpiry);
      if (!isNaN(parsedDate.getTime())) {
        this.ShareFileExpiry = parsedDate;
      } else {
        this.ShareFileExpiry = null;
      }
    }
  }
}
